import React from 'react'
import HeroSection from './HeroSection/HeroSection'
import AboutSection from './AboutSection/AboutSection'
import ServiceSection from './ServiceSection/ServiceSection'
import HotBitSection from './HotBitCardSection/HotBitSection'
import Collection from './CollectionSection/Collection'
import CategoryCard from './CategoryCardSection/CategoryCard'
import CreateSection from './CreateSection/CreateSection'
import TeamSection from './TeamSection/TeamSection'
import BoxSection from './BoxSection/BoxSection'
import BlogSection from './BlogSection/BlogSection'

const Home = () => {
  return (
    <div>
      <HeroSection/>
      <AboutSection/>
      <ServiceSection/>
      <HotBitSection/>
      <Collection/>
      <CategoryCard/>
      <CreateSection/>
      <TeamSection/>
      <BlogSection/>
      <BoxSection/>
    </div>
  )
}

export default Home
